import { FaSeedling, FaTools, FaCalendar, FaClock, FaMapMarkerAlt, FaUserTie, FaHashtag, FaEnvelope, FaDollarSign, FaUser, FaTags, FaBusinessTime, FaBriefcase, FaMoneyBillWave, FaHourglassEnd, FaCalendarAlt } from 'react-icons/fa';
import { FaLeaf, FaLightbulb, FaTree, FaWater } from 'react-icons/fa6';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {
 
    // Service Icons
    case 'lawn maintenance':
      return <FaLeaf />; // Return the FaCouch icon for interior design
    case 'garden design':
      return <FaSeedling />; // Return the FaHome icon for exterior design
    case 'tree planting':
      return <FaTree />; // Return the FaPencilRuler icon for architectural design
    case 'hardscaping':
      return <FaTools />; // Return the FaBuilding icon for building construction
    case 'water features':
      return <FaWater />; // Return the FaRoad icon for road repair
    case 'outdoor lighting':
      return <FaLightbulb />; // Return the FaPaintRoller icon for renovation

    // Event Single
    case 'date':
      return <FaCalendar />; // Calendar icon for date selection
    case 'time':
      return <FaClock />; // Clock icon for time selection
    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon for location
    case 'organizer':
      return <FaUserTie />; // UserTie icon for event organizer
    case 'number':
      return <FaHashtag />; // Hashtag icon for numerical values
    case 'email':
      return <FaEnvelope />; // Envelope icon for email input
    case 'fee':
      return <FaDollarSign />; // Dollar sign icon for fees/cost

    // Project Single
    case 'client':
      return <FaUser />; // User icon for client representation
    case 'category':
      return <FaTags />; // Tags icon for project category
    case 'duration':
      return <FaClock />; // Clock icon for project duration
    case 'area':
      return <FaMapMarkerAlt />; // Map marker icon for project area/location
    case 'cost':
      return <FaDollarSign />; // Dollar sign icon for project cost
    case 'designer':
      return <FaUserTie />; // UserTie icon for project designer

    // Career Single
    case 'timing':
      return <FaClock />; // Clock icon for general timing
    case 'hours':
      return <FaBusinessTime />; // BusinessTime icon for working hours
    case 'experience':
      return <FaBriefcase />; // Briefcase icon for experience level
    case 'position':
      return <FaUserTie />; // UserTie icon for job position
    case 'days':
      return <FaCalendarAlt />; // Calendar icon for days worked
    case 'salary':
      return <FaMoneyBillWave />; // MoneyBillWave icon for salary representation
    case 'deadline':
      return <FaHourglassEnd />; // HourglassEnd icon for deadline

    default:
      return null; // If no matching service name is found, return null

  }

};